// Generated by scripts/build-ui-icons.mjs.
export { CaretDoubleLeft as default } from "../ui/glyphs-2";
